module.exports = __webpack_public_path__ + "img/2025-0325-01-02.219bd8ba.png";